export async function saveRecordedTranscript(supabase, row) {
  let result = await supabase.from('consultations').insert([row]).select('id');
  if (result.error?.code === '23505') {
    // An earlier insert may have committed before its response was lost.
    // Read that row instead of overwriting edits made since it was saved.
    result = await supabase.from('consultations').select('*')
      .eq('id', row.id).eq('patient_id', row.patient_id);
    if (!result.error && result.data?.[0]?.id) {
      const existing = { ...result.data[0] };
      for (const field of ['transcription', 'notes', 'chiefComplaint', 'created_by']) {
        if (typeof existing[field] === 'string' && existing[field]) {
          const decrypted = await supabase.rpc('decrypt_text', { encrypted_data: existing[field] });
          if (decrypted.error) throw decrypted.error;
          existing[field] = decrypted.data;
        }
      }
      return { ...row, ...existing };
    }
  }
  if (result.error || !result.data?.[0]?.id) {
    throw result.error || new Error('Could not save transcription');
  }
  return { ...row, id: result.data[0].id };
}
